
<template>
	<div class="orl">
		<van-sticky>
			<div class="orl_head">
				
				<div @click="switchPageType('all')" :class="[{'orl_head_itemS':page_type=='all'},'orl_head_item']">
					<div class="orl_head_item_txt">全部</div>
					<div v-if="page_type=='all'" class="orl_head_item_line"></div>
				</div>
				<div @click="switchPageType('unused')" :class="[{'orl_head_itemS':page_type=='unused'},'orl_head_item']">
					<div class="orl_head_item_txt">待使用</div>
					<div v-if="page_type=='unused'" class="orl_head_item_line"></div>
				</div>
				<div @click="switchPageType('used')" :class="[{'orl_head_itemS':page_type=='used'},'orl_head_item']">
					<div class="orl_head_item_txt">已完成</div>
					<div v-if="page_type=='used'" class="orl_head_item_line"></div>
				</div>
				<div @click="switchPageType('canceled')" :class="[{'orl_head_itemS':page_type=='canceled'},'orl_head_item']">
					<div class="orl_head_item_txt">已取消</div>
					<div v-if="page_type=='canceled'" class="orl_head_item_line"></div>
				</div>
			</div>
		</van-sticky>
		
		
		<div v-if="is_load">
			<div v-if="venus_list.length>0">
			<van-list v-model="loading" :finished="finished" :offset="10" finished-text="没有更多了" @load="onLoadNextPage">
				<div class="orl_list">
					<div v-for="(item,index) in venus_list" :key="index" @click="toDetail(item)" class="orl_list_item">
						<div class="orl_list_item_head">
							<div class="orl_list_item_head_left">
								<!-- <img v-if="item.icon" :src="item.icon" alt="" /> -->
								商品名称
							</div>
							<div :class="[{'orl_list_item_head_rightS':index<=1},'orl_list_item_head_right']">
								<!-- 
								{{item.book_status==1?'待使用':item.book_status==2?'已完成':item.book_status==3?'已取消':''}}
								-->
								待使用
							</div>
						</div>
						<div class="orl_list_item_body">
							<van-image fit="cover" class="orl_list_item_body_left" src="https://img01.yzcdn.cn/vant/cat.jpeg" />
							<div class="orl_list_item_body_right">
								<div class="orl_list_item_body_right_1">场馆名称</div>
								<div v-if="item.product_type && item.product_type=='voucher'" class="orl_list_item_body_right_2">有效期：有效期有效期有效期</div>
								<div v-else class="orl_list_item_body_right_2">预约时间：预约时间预约时间预约时间</div>
								<div class="orl_list_item_body_right_2">订单金额：¥999</div>
							</div>
						</div>
					</div>
				</div>
			</van-list>
			</div>
			<div v-else>
				<empty />
			</div>
		</div>
		
		<!-- 
		参数	说明	类型	默认值
			v-model	是否处于加载状态，加载过程中不触发load事件	boolean	false
			finished	是否已加载完成，加载完成后不再触发load事件	boolean	false
			error	是否加载失败，加载失败后点击错误提示可以重新 触发load事件，必须使用sync修饰符	boolean	false
			offset	滚动条与底部距离小于 offset 时触发load事件	number | string	300
			loading-text	加载过程中的提示文案	string	加载中...
			finished-text	加载完成后的提示文案	string	-
			error-text	加载失败后的提示文案	string	-
			immediate-check	是否在初始化时立即执行滚动位置检查	boolean	true
			direction	滚动触发加载的方向，可选值为up	string	down
		 -->
		
		<!-- <div v-if="is_load && venus_list.length>0" class="pz_list"></div>
		<div v-if="is_load && venus_list.length==0" class="pz_list">
			<empty />
		</div> -->
	</div>
</template>

<script>
	import empty from '../components/empty.vue';
	import {
		futureTimesGroup,
		datePrintStr
	} from "../lib/utils.js"
	export default {
		components: {
			empty
		},
		data() {
			return {
				is_load: false,
				
				page_type:'all',//unused 待使用 used 已使用 canceled 已取消 all 全部
				
				

				page: 1,
				page_size: 20,
				venus_list:[],//列表
				
				loading:true,//是否处于加载状态，加载过程中不触发load事件
				finished:false,//是否已加载完成，加载完成后不再触发load事件
			}
		},
		mounted() {
			document.title = '订单列表'
			this.getOrderListBefore()
		},
		methods: {
			// 切换页面类型
			switchPageType(e){
				var $this=this
				this.$loading('正在加载中...');
				this.page_type=e
				this.getOrderListBefore()
			},
			// 获取订单列表
			getOrderListBefore(){
				this.$loading('正在加载中...');
				this.is_load=false
				this.page=1
				this.venus_list=[]
				this.loading=true,
				this.finished=false
				this.getOrderList()
			},
			getOrderList(){
				console.log('获取订单列表');
				var $this=this
				setTimeout(()=>{
					var venus_list=[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19]
					if ($this.page == 1) {
						$this.venus_list = venus_list
						$this.loading=false
						$this.finished=venus_list.length<$this.page_size?true:false
						$this.is_load = true
					} else {
						$this.venus_list = [...$this.venus_list, ...venus_list]
						$this.loading=false
						$this.finished=venus_list.length<$this.page_size?true:false
						$this.is_load = true
					}
					$this.$loading.close();
				},200)
				return
				
				var $this=this
				var param={
					page:this.page,
					offset:this.page_size,
					status:this.page_type
				}
				var qs = require('qs');
				let url = this.api.userApi.order_orderList
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						console.log(res);
						var venus_list=res.data.list
						if ($this.page == 1) {
							$this.venus_list = venus_list
							$this.loading=false
							$this.finished=venus_list.length<$this.page_size?true:false
							$this.is_load = true
						} else {
							$this.venus_list = [...$this.venus_list, ...venus_list]
							$this.loading=false
							$this.finished=venus_list.length<$this.page_size?true:false
							$this.is_load = true
						}
						$this.$loading.close();
						
					}).catch((error) => {
						$this.$toast(error.msg);
						$this.$loading.close();
					})
				
				
				
				
			},
			// 加载下一页
			onLoadNextPage(){
				this.$loading('正在加载中...');
				this.loading=true
				this.page=this.page+1
				this.getOrderList()
			},
			// 查看详情
			toDetail(e){
				// this.$router.push({
				// 	name:'order_detail',
				// 	params:{
				// 		order_no:e.order_no
				// 	}
				// })
			},

		},
	}
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;
	.orl{
		width: 100%;
		min-height: 100vh;
		background: #F6F7F9;
		padding-bottom: 20*@vm_base;
		// padding-bottom: calc(constant(safe-area-inset-bottom) / 2+ 120*@vm_base);
		// padding-bottom: calc(env(safe-area-inset-bottom) / 2 + 120*@vm_base);
	}
	.orl_head{
		width: 100%;
		background: #F6F7F9;
		padding: 0 20*@vm_base;
		display: flex;
		justify-content: space-between;
		align-items: center;
		.orl_head_item{
			width: fit-content;
			padding: 20*@vm_base 20*@vm_base 0 20*@vm_base;
			height: 100*@vm_base;
			color: #666666;
			.orl_head_item_txt{
				font-size: 28*@vm_base;
			}
			.orl_head_item_line{
				width: 40*@vm_base;
				height: 4*@vm_base;
				background: linear-gradient( 319deg, #FB8027 0%, #FFA663 100%);
				border-radius: 2*@vm_base;
				margin: 0 auto;
				margin-top: 16*@vm_base;
			}
		}
		.orl_head_itemS{
			color: #F77F28;
		}
	}
	.orl_list{
		width: 100%;
		padding: 0 20*@vm_base;
	}
	.orl_list_item{
		width: 100%;
		background: #FFFFFF;
		border-radius: 8*@vm_base;
		margin-bottom: 20*@vm_base;
		padding: 30*@vm_base 20*@vm_base;
		.orl_list_item_head{
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
			.orl_list_item_head_left{
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: 30*@vm_base;
				color: #333333;
				img{
					width: 40*@vm_base;
					margin-right: 16*@vm_base;
				}
			}
			.orl_list_item_head_right{
				font-size: 26*@vm_base;
				color: #666666;
			}
			.orl_list_item_head_rightS{
				color: #F77F28;
			}
		}
		.orl_list_item_body{
			width: 100%;
			margin-top: 20*@vm_base;
			display: flex;
			justify-content: space-between;
			align-items: flex-start;
			.orl_list_item_body_left{
				width: 280*@vm_base;
				height: 200*@vm_base;
				border-radius: 8*@vm_base;
				overflow: hidden;
			}
			.orl_list_item_body_right{
				width: calc(100% - 300*@vm_base);
				.orl_list_item_body_right_1{
					width: 100%;
					font-size: 28*@vm_base;
					color: #333333;
					line-height: 1.5;
					padding-bottom: 10*@vm_base;
				}
				.orl_list_item_body_right_2{
					width: 100%;
					font-size: 24*@vm_base;
					color: #666666;
					line-height: 1.5;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/order_list.vue